import { render, staticRenderFns } from "./BaseScrollable.vue?vue&type=template&id=23dcd7ab&scoped=true&"
import script from "./BaseScrollable.vue?vue&type=script&lang=ts&"
export * from "./BaseScrollable.vue?vue&type=script&lang=ts&"
import style0 from "./BaseScrollable.vue?vue&type=style&index=0&id=23dcd7ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dcd7ab",
  null
  
)

export default component.exports